import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import palette from '../theme/palette';
// import YellowFolderSvg from '../svg/folderYellow.svg';
import ColorFilesSvg from '../svg/colorFile.svg';
import ColorLinkSvg from '../svg/colorLink.svg';
import YoutubeSvg from '../svg/colorYoutube.svg';
import Modal from './common/Modal';
import ResourceFileModal from './resourceModalTabs/FileModal';
import ResourceYoutubeOrLinkModal from './resourceModalTabs/YoutubeOrLinkModal';

const useStyles = makeStyles({
  subTitle: {
    fontSize: 16,
    color: palette.grey[500]
  },
  resourceContainer: {
    borderRadius: 5,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0',
    cursor: 'pointer'
  },
  resourceTitle: {
    marginTop: '15px'
  },
  dialogPaper: {
    minHeight: '355px !important',
    width: '500px !important'
  },
  alignHorizontalCenter: {
    display: 'flex',
    flexDirection: 'center',
    justifyContent: 'center'
  }
});

// const FolderContent = ({ onCancel }) => {
//   const [folderName, setFolderName] = useState('');
//   return (
//     <>
//       <DialogTitle style={{ display: 'flex', alignItems: 'center' }}>
//         <IconButton style={{ marginRight: 10 }} onClick={() => onCancel()}>
//           <BackArrowIcon />
//         </IconButton>{' '}
//         Choose Type
//       </DialogTitle>
//       <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//         <TextField
//           margin="dense"
//           label="Folder Name"
//           name="folderName"
//           type="text"
//           fullWidth
//           onChange={(e) => {
//             setFolderName(e.target.value);
//           }}
//         />
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={() => onCancel()} color="primary">
//           Cancel
//         </Button>
//         <Button onClick={() => {}} color="primary">
//           Save
//         </Button>
//       </DialogActions>
//     </>
//   );
// };

// FolderContent.propTypes = {
//   onCancel: PropTypes.func
// };

export default function AddResourceModal({ editObj, open, onClose, fetchData }) {
  const classes = useStyles();
  const [selectedRes, setSelRes] = useState('');

  useEffect(() => {
    if (editObj) {
      setSelRes(editObj.type);
    }
  }, [editObj]);

  if (selectedRes === 'file') {
    return (
      <ResourceFileModal
        onCancel={() => setSelRes('')}
        open={open}
        onClose={() => {
          setSelRes('');
          onClose();
        }}
        fetchData={fetchData}
      />
    );
  }

  if (selectedRes === 'link' || selectedRes === 'youtube') {
    return (
      <ResourceYoutubeOrLinkModal
        open={open}
        title={`${editObj ? 'Update' : 'Add'} ${selectedRes === 'link' ? 'Link' : 'Youtube Video'}`}
        editObj={editObj}
        onCancel={
          editObj
            ? () => {
                setSelRes('');
                onClose();
              }
            : () => setSelRes('')
        }
        onClose={() => {
          setSelRes('');
          onClose();
        }}
      />
    );
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <>
          Choose Type
          <p className={classes.subTitle}>
            Select the type of resources you want to upload to the list.
          </p>
        </>
      }
    >
      {selectedRes === '' && (
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
                <div
                  className={classes.resourceContainer}
                  role="presentation"
                  onClick={() => setSelRes('folder')}
                >
                  <img src={YellowFolderSvg} alt="folder" />
                  <p className={classes.resourceTitle}>Folder</p>
                </div>
              </Grid> */}
          <Grid item xs={12} sm={6}>
            <div
              className={classes.resourceContainer}
              role="presentation"
              onClick={() => setSelRes('file')}
            >
              <img src={ColorFilesSvg} alt="files" />
              <p className={classes.resourceTitle}>Files</p>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div
              className={classes.resourceContainer}
              role="presentation"
              onClick={() => setSelRes('link')}
            >
              <img src={ColorLinkSvg} alt="link" />
              <p className={classes.resourceTitle}>Links</p>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div
              className={classes.resourceContainer}
              role="presentation"
              onClick={() => setSelRes('youtube')}
            >
              <img src={YoutubeSvg} alt="youtube" />
              <p className={classes.resourceTitle}>Youtube Video</p>
            </div>
          </Grid>
        </Grid>
      )}
      {/* {selectedRes === 'folder' && <FolderContent onCancel={() => setSelRes('')} />} */}
    </Modal>
  );
}

AddResourceModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  editObj: PropTypes.shape({
    type: PropTypes.string
  }),
  fetchData: PropTypes.func
};
